// import React from "react";
// import { Box, TextField, Button, Typography, Container, Paper, Stack } from "@mui/material";
// import UploadWithLabel from "./uploadWithLable";
// import { useFormik } from "formik";
// import * as Yup from "yup";
// import { useTranslation } from "react-i18next";

// const AfidavitCustComponent = ({
//   handleInputChange,
//   setAffidavit,
//   affidavit,
//   cust,
//   setCust,
//   base,
//   setActiveTab,
//   activeTab,
//   setBase,
// }) => {
//   const { t } = useTranslation();

//   const validationSchema = Yup.object({
//     doc1: Yup.mixed()
//       .required(t('afidavit.validation.doc1Required'))
//       .test("fileExists", t('afidavit.validation.doc1Required'), (value) => value != null)
//       .test("fileType", "Affidavit must be PDF only", (value) => !value || value.type === "application/pdf")
//       .test("fileSize", t('baseInfo.validation.fileSizeExceeded'), value => !value || value.size <= 2 * 1024 * 1024),
//     cust_id: Yup.string().required(t('afidavit.validation.custIdRequired')),
//     doc: Yup.mixed()
//       .required(t('afidavit.validation.docRequired'))
//       .test("fileExists", t('afidavit.validation.docRequired'), (value) => value != null)
//       .test("fileType", "Customer ID proof must be PDF only", (value) => !value || value.type === "application/pdf")
//       .test("fileSize", t('baseInfo.validation.fileSizeExceeded'), value => !value || value.size <= 2 * 1024 * 1024),
//   });

//   const formik = useFormik({
//     initialValues: { doc1: affidavit.doc1, cust_id: cust.cust_id, doc: cust.doc },
//     validationSchema,
//     enableReinitialize: true,
//     onSubmit: (values) => {
//       setAffidavit({ doc1: values.doc1 });
//       setCust({ cust_id: values.cust_id, doc: values.doc });
//       setActiveTab(activeTab + 1);
//     },
//   });

//   const handleFileChangeFormik = (e, fieldName) => {
//     const file = e.currentTarget.files[0] || null;
//     formik.setFieldValue(fieldName, file);
//     formik.setFieldTouched(fieldName, true);
//   };

//   return (
//     <Container maxWidth={false} sx={{ mt: 5, maxWidth: 800 }}>
//       <Paper elevation={4} sx={{ p: 4, borderRadius: 3 }}>
//         <Typography variant="h4" color="primary.main" fontWeight="700" align="center" gutterBottom>
//           {t('afidavit.heading')}
//         </Typography>

//         <Box component="form" noValidate onSubmit={formik.handleSubmit}>
//           <Stack spacing={3}>
//             <UploadWithLabel
//               label={t('afidavit.uploadAffidavit')}
//               name="doc1"
//               onChange={(e) => handleFileChangeFormik(e, "doc1")}
//               file={formik.values.doc1}
//               error={formik.touched.doc1 && Boolean(formik.errors.doc1)}
//               helperText={formik.touched.doc1 && formik.errors.doc1}
//             />
//             {formik.touched.doc1 && formik.errors.doc1 && (
//               <Typography color="error" variant="caption" sx={{ ml: 2 }}>
//                 {formik.errors.doc1}
//               </Typography>
//             )}

//             <TextField
//               margin="normal"
//               label={t('afidavit.customerId')}
//               name="cust_id"
//               value={formik.values.cust_id}
//               onChange={formik.handleChange}
//               onBlur={formik.handleBlur}
//               fullWidth
//               error={formik.touched.cust_id && Boolean(formik.errors.cust_id)}
//               helperText={formik.touched.cust_id && formik.errors.cust_id}
//             />

//             <UploadWithLabel
//               label={t('afidavit.uploadCustomerIdProof')}
//               name="doc"
//               onChange={(e) => handleFileChangeFormik(e, "doc")}
//               file={formik.values.doc}
//               error={formik.touched.doc && Boolean(formik.errors.doc)}
//               helperText={formik.touched.doc && formik.errors.doc}
//             />
//             {formik.touched.doc && formik.errors.doc && (
//               <Typography color="error" variant="caption" sx={{ ml: 2 }}>
//                 {formik.errors.doc}
//               </Typography>
//             )}

//             <Box mt={1} sx={{ display: "flex", justifyContent: "space-between" }}>
//               <Button
//                 variant="outlined"
//                 size="large"
//                 onClick={() => {
//                   if (activeTab > 0) setActiveTab(activeTab - 1);
//                 }}
//               >
//                 {t('common.back')}
//               </Button>
//               <Button
//                 type="submit"
//                 variant="contained"
//                 size="large"
//                 sx={{
//                   "&.Mui-disabled": {
//                     backgroundColor: "rgba(25, 118, 210, 0.6)",
//                     color: "rgba(255, 255, 255, 0.9)",
//                     cursor: "not-allowed",
//                   },
//                 }}
//               >
//                 {t('common.next')}
//               </Button>
//             </Box>
//           </Stack>
//         </Box>
//       </Paper>
//     </Container>
//   );
// };

// export default AfidavitCustComponent;


import React from "react";
import { Box, TextField, Button, Typography, Container, Paper, Stack } from "@mui/material";
import UploadWithLabel from "./uploadWithLable";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import AssignmentIcon from "@mui/icons-material/Assignment";
import FingerprintIcon from "@mui/icons-material/Fingerprint";

// ─── shared sx helpers ────────────────────────────────────────────────
const fieldSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "12px",
    background: "#f8fafc",
    fontFamily: "'DM Sans', sans-serif",
    fontSize: "0.95rem",
    "& fieldset": { borderColor: "#e2e8f0" },
    "&:hover fieldset": { borderColor: "#3b82f6" },
    "&.Mui-focused fieldset": { borderColor: "#3b82f6", borderWidth: 2 },
  },
  "& .MuiInputLabel-root": {
    fontFamily: "'DM Sans', sans-serif",
    fontSize: "0.9rem",
    "&.Mui-focused": { color: "#3b82f6" },
  },
};

const SectionCard = ({ icon, title, children }) => (
  <Box
    sx={{
      border: "1.5px solid #e8f0fe",
      borderRadius: "16px",
      p: 3,
      background: "linear-gradient(135deg, #fafcff 0%, #f0f6ff 100%)",
      position: "relative",
      overflow: "hidden",
      "&::before": {
        content: '""',
        position: "absolute",
        top: 0,
        left: 0,
        width: "4px",
        height: "100%",
        background: "linear-gradient(180deg, #3b82f6, #8b5cf6)",
        borderRadius: "16px 0 0 16px",
      },
    }}
  >
    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 2.5 }}>
      <Box
        sx={{
          width: 36,
          height: 36,
          borderRadius: "10px",
          background: "linear-gradient(135deg, #3b82f6, #8b5cf6)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxShadow: "0 4px 12px rgba(59,130,246,0.3)",
        }}
      >
        {React.cloneElement(icon, { sx: { color: "#fff", fontSize: 18 } })}
      </Box>
      <Typography sx={{ fontWeight: 700, fontSize: "0.95rem", color: "#1e293b", fontFamily: "'DM Sans', sans-serif" }}>
        {title}
      </Typography>
    </Box>
    {children}
  </Box>
);

const AfidavitCustComponent = ({
  handleInputChange,
  setAffidavit,
  affidavit,
  cust,
  setCust,
  base,
  setActiveTab,
  activeTab,
  setBase,
}) => {
  const { t } = useTranslation();

  const validationSchema = Yup.object({
    doc1: Yup.mixed()
      .required(t("afidavit.validation.doc1Required"))
      .test("fileExists", t("afidavit.validation.doc1Required"), (value) => value != null)
      .test("fileType", "Affidavit must be PDF only", (value) => !value || value.type === "application/pdf")
      .test("fileSize", t("baseInfo.validation.fileSizeExceeded"), (value) => !value || value.size <= 2 * 1024 * 1024),
    cust_id: Yup.string().required(t("afidavit.validation.custIdRequired")),
    doc: Yup.mixed()
      .required(t("afidavit.validation.docRequired"))
      .test("fileExists", t("afidavit.validation.docRequired"), (value) => value != null)
      .test("fileType", "Customer ID proof must be PDF only", (value) => !value || value.type === "application/pdf")
      .test("fileSize", t("baseInfo.validation.fileSizeExceeded"), (value) => !value || value.size <= 2 * 1024 * 1024),
  });

  const formik = useFormik({
    initialValues: { doc1: affidavit.doc1, cust_id: cust.cust_id, doc: cust.doc },
    validationSchema,
    enableReinitialize: true,
    onSubmit: (values) => {
      setAffidavit({ doc1: values.doc1 });
      setCust({ cust_id: values.cust_id, doc: values.doc });
      setActiveTab(activeTab + 1);
    },
  });

  const handleFileChangeFormik = (e, fieldName) => {
    const file = e.currentTarget.files[0] || null;
    formik.setFieldValue(fieldName, file);
    formik.setFieldTouched(fieldName, true);
  };

  return (
    <Container maxWidth={false} sx={{ mt: 3, maxWidth: 800 }}>
      <Paper
        elevation={0}
        sx={{
          p: 4,
          borderRadius: "24px",
          border: "1.5px solid #e2e8f0",
          background: "#fff",
          boxShadow: "0 8px 40px rgba(59,130,246,0.08)",
        }}
      >
        {/* Header */}
        <Box sx={{ textAlign: "center", mb: 4 }}>
          <Typography
            variant="h5"
            sx={{
              fontWeight: 800,
              fontFamily: "'DM Sans', sans-serif",
              background: "linear-gradient(135deg, #1e293b 0%, #3b82f6 100%)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              mb: 0.5,
            }}
          >
            {t("afidavit.heading")}
          </Typography>
          <Typography sx={{ color: "#94a3b8", fontSize: "0.85rem", fontFamily: "'DM Sans', sans-serif" }}>
            Upload required documents to proceed
          </Typography>
        </Box>

        <Box component="form" noValidate onSubmit={formik.handleSubmit}>
          <Stack spacing={3}>
            {/* Affidavit Section */}
            <SectionCard icon={<AssignmentIcon />} title="Affidavit Document">
              <UploadWithLabel
                label={t("afidavit.uploadAffidavit")}
                name="doc1"
                onChange={(e) => handleFileChangeFormik(e, "doc1")}
                file={formik.values.doc1}
                error={formik.touched.doc1 && Boolean(formik.errors.doc1)}
                helperText={formik.touched.doc1 && formik.errors.doc1}
              />
            </SectionCard>

            {/* Customer Section */}
            <SectionCard icon={<FingerprintIcon />} title="Customer Identification">
              <Stack spacing={2.5}>
                <TextField
                  label={t("afidavit.customerId")}
                  name="cust_id"
                  value={formik.values.cust_id}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  fullWidth
                  error={formik.touched.cust_id && Boolean(formik.errors.cust_id)}
                  helperText={formik.touched.cust_id && formik.errors.cust_id}
                  sx={fieldSx}
                />
                <UploadWithLabel
                  label={t("afidavit.uploadCustomerIdProof")}
                  name="doc"
                  onChange={(e) => handleFileChangeFormik(e, "doc")}
                  file={formik.values.doc}
                  error={formik.touched.doc && Boolean(formik.errors.doc)}
                  helperText={formik.touched.doc && formik.errors.doc}
                />
              </Stack>
            </SectionCard>

            {/* Navigation */}
            <Box sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}>
              <Button
                variant="outlined"
                size="large"
                onClick={() => { if (activeTab > 0) setActiveTab(activeTab - 1); }}
                sx={{
                  borderRadius: "12px",
                  borderColor: "#e2e8f0",
                  color: "#64748b",
                  fontWeight: 600,
                  fontFamily: "'DM Sans', sans-serif",
                  px: 3,
                  "&:hover": { borderColor: "#3b82f6", color: "#3b82f6", background: "#eff6ff" },
                }}
              >
                {t("common.back")}
              </Button>
              <Button
                type="submit"
                variant="contained"
                size="large"
                sx={{
                  borderRadius: "12px",
                  background: "linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%)",
                  fontWeight: 700,
                  fontFamily: "'DM Sans', sans-serif",
                  px: 4,
                  boxShadow: "0 4px 20px rgba(59,130,246,0.35)",
                  "&:hover": {
                    background: "linear-gradient(135deg, #2563eb 0%, #7c3aed 100%)",
                    boxShadow: "0 6px 28px rgba(59,130,246,0.45)",
                    transform: "translateY(-1px)",
                  },
                  "&.Mui-disabled": {
                    background: "linear-gradient(135deg, rgba(59,130,246,0.5) 0%, rgba(139,92,246,0.5) 100%)",
                    color: "#fff",
                  },
                  transition: "all 0.25s ease",
                }}
              >
                {t("common.next")} →
              </Button>
            </Box>
          </Stack>
        </Box>
      </Paper>
    </Container>
  );
};

export default AfidavitCustComponent;